import { Button, Form, Input, Modal, Spin, message } from 'antd';
import { useState, useRef } from 'react';
import Constants from '../../../lib/Constants';
import { useSelector } from 'react-redux';
import { truncateSerial } from '../../../lib/utils';

const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 },
};

const tailLayout = {
  wrapperCol: { offset: 8, span: 16 },
};

const Addcaja = props => {
  const [form] = Form.useForm();
  const [isProcessing, setIsProcessing] = useState(false);
  const cajaInputRef = useRef(null);

  const userdata = useSelector(state => state.userdata);
  const omitir1 = useSelector(state => state.omitir1.omitir1);
  console.log('props.producto', props.producto);
  console.log('props.ingresados', props.ingresados);
  console.log('pendientes', props.producto.cantidad - props.ingresados);
  const onFinish = async values => {
    setIsProcessing(true);

    const inicial = values.inicial;
    const final = values.final;
    const inicialNum = parseInt(inicial);
    const finalNum = parseInt(final);
    const cantidadSeriales = Math.abs(finalNum - inicialNum) + 1;
    const largo = inicial.length;
    const largodedatos = parseInt(final) - parseInt(inicial) + 1;
    const pendientes = props.producto.cantidad - props.ingresados;
    // Validaciones
    
    console.log('props.ingresados', props.ingresados);
    console.log('pendientes', pendientes);
    console.log('cantidadSeriales', cantidadSeriales);
    if (
      pendientes < cantidadSeriales ||
      cantidadSeriales > pendientes
    ) {
      Modal.error({
        title: 'Validación de cantidad',
        content: `No hay suficientes productos disponibles.
          Cantidad solicitada: ${cantidadSeriales}
          Cantidad disponible: ${
            pendientes
          }`,
      });
      setIsProcessing(false);
      return;
    }

    if (
      largo < props.producto.producto_detalle.grupo.codebarmin ||
      largo > props.producto.producto_detalle.grupo.codebarmax
    ) {
      Modal.error({
        title: 'Error de formato',
        content: `El tamaño del serial debe estar entre ${props.producto.producto_detalle.grupo.codebarmin} 
          y ${props.producto.producto_detalle.grupo.codebarmax} caracteres`,
      });
      setIsProcessing(false);
      return;
    }

    if (
      props.producto.cantidad < largodedatos ||
      props.producto.cantidad - props.producto.seriales.length < largodedatos
    ) {
      Modal.error({
        title: 'Validación de tamaño de archivo',
        content: `Los seriales contienen ${largodedatos} registros y la cantidad de registros a subir son ${
          props.producto.cantidad - props.producto.seriales.length
        }!`,
      });
      setIsProcessing(false);
      return;
    }

    try {
      const payload = {
        inicial: truncateSerial(inicial, omitir1),
        final: truncateSerial(final, omitir1),
        caja: truncateSerial(values.caja, omitir1),
        productoId: props.producto.producto_detalle.id,
        productoOdcId: props.producto.id,
        ordenCompraIngreso: props.order,
        bodegaId: props.bodegaId,
        userId: userdata.id,
      };

      const response = await fetch(
        `${Constants.URL_COMPLEMENTO}/api/seriales`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        }
      );

      const data = await response.json();

      if (response.ok) {
        console.log('data res', data);

        if (data.duplicados && data.duplicados.length > 0) {
          Modal.warning({
            title: 'Seriales insertados con duplicados',
            content: (
              <div>
                <p>{data.message}</p>
                <p style={{ color: 'red' }}>
                  Total de duplicados y no insertados: {data.totalDuplicados}
                </p>
                <p>Seriales duplicados:</p>
                <div
                  style={{
                    display: 'grid',
                    gridTemplateColumns: '1fr 1fr 1fr 1fr',
                    fontSize: '0.5em',
                    maxHeight: '200px',
                    overflowY: 'auto',
                    border: '1px solid #d9d9d9',
                    padding: '8px',
                    borderRadius: '4px',
                  }}
                >
                  {data.duplicados.map((item, index) => (
                    <div key={index}>
                      {typeof item === 'object' ? item.serial : String(item)}
                    </div>
                  ))}
                </div>
                <Button
                  type="primary"
                  style={{ marginTop: '10px' }}
                  onClick={() => {
                    const content = data.duplicados
                      .map(item =>
                        typeof item === 'object' ? item.serial : String(item)
                      )
                      .join('\n');
                    const blob = new Blob([content], { type: 'text/plain' });
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = 'seriales_duplicados.txt';
                    document.body.appendChild(a);
                    a.click();
                    window.URL.revokeObjectURL(url);
                    document.body.removeChild(a);
                  }}
                >
                  Descargar duplicados en TXT
                </Button>
              </div>
            ),
          });
          message.success(data.message, 1);
        } else {
          message.success(data.message, 1);
        }

        form.resetFields();
        if (props.onSuccess) {
          props.onSuccess();
        }
        cajaInputRef.current?.focus();
      } else {
      
        throw { message: data.message, detail: data?.error?.detail };
      }
    } catch (error) {
      console.error('Error processing serials:', error);
      Modal.error({
        title: 'Error en el proceso',
        content: (
          <div>
            <div>Ocurrió un error al procesar los seriales</div>
            {error.message && (
              <div style={{ marginTop: 8 }}><b>Mensaje:</b> {error.message}</div>
            )}
            {error.detail && (
              <div style={{ marginTop: 8, color: 'red' }}><b>Detalle:</b> {error.detail}</div>
            )}
          </div>
        ),
        onOk: () => {
          setIsProcessing(false);
        },
      });
    } finally {
      setIsProcessing(false);
    }
  };

  const onReset = () => {
    form.resetFields();
  };

  const handleKeyDown = e => {
    if (e.key === 'Enter' || e.key === 'Tab') {
      e.preventDefault();
      const formElements = Array.from(document.querySelectorAll('input'));
      const currentIndex = formElements.indexOf(document.activeElement);
      const nextIndex = (currentIndex + 1) % formElements.length;
      formElements[nextIndex].focus();
    }
  };

  const handleKeyDownfinal = e => {
    if (e.key === 'Enter' || e.key === 'Tab') {
      e.preventDefault();
      form.submit();
    }
  };

  return (
    <Form {...layout} form={form} name="control-hooks" onFinish={onFinish}>
      <Form.Item
        name="caja"
        label="Caja"
        onKeyDown={handleKeyDown}
        rules={[{ required: true }]}
      >
        <Input ref={cajaInputRef} />
      </Form.Item>

      <Form.Item
        name="inicial"
        label="Inicial"
        onKeyDown={handleKeyDown}
        rules={[{ required: true }]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        name="final"
        label="Final"
        onKeyDown={handleKeyDownfinal}
        rules={[{ required: true }]}
      >
        <Input />
      </Form.Item>

      {isProcessing && (
        <Form.Item label="Procesando">
          <Spin tip="Procesando seriales..." />
        </Form.Item>
      )}

      <Form.Item {...tailLayout}>
        <Button type="primary" htmlType="submit" loading={isProcessing}>
          Procesar
        </Button>
        <Button htmlType="button" onClick={onReset} disabled={isProcessing}>
          Reset
        </Button>
      </Form.Item>
    </Form>
  );
};

export default Addcaja;
